export const COMPETITOR_DISCOVERY_RULES_VERSION = "competitor-discovery-rules@0.2.0";

export const COMPETITOR_ANALYSIS_RULES_VERSION = "competitor-analysis-rules@0.1.0";

export const COMPETITOR_DISCOVERY_RUN_STATUS_LABELS = {
  created: "Ожидает",
  running: "Выполняется",
  completed: "Завершён",
  completed_with_warnings: "Завершён с предупреждениями",
  failed: "Не выполнен",
} as const;

export const COMPETITOR_DISCOVERY_PHASE_LABELS = {
  own_card: "Своя карточка",
  candidates: "Кандидаты",
} as const;

export const COMPETITOR_CANDIDATE_STATUS_LABELS = {
  pending_review: "Ожидает проверки",
  direct_competitor: "Прямой конкурент",
  close_analogue: "Близкий аналог",
  excluded: "Не конкурент",
} as const;

export const COMPETITOR_MATCH_GROUP_LABELS = {
  likely_direct: "Похож на прямого конкурента",
  possible_analogue: "Возможный аналог",
  low_relevance: "Низкое совпадение",
  insufficient_data: "Мало данных",
} as const;

export const COMPETITOR_CONFIDENCE_LABELS = {
  high: "Высокая",
  medium: "Средняя",
  low: "Низкая",
} as const;

export const COMPETITOR_EVIDENCE_SOURCE_LABELS = {
  title_search: "Поиск по названию",
  search_query: "Запрос карточки",
  shared_serp: "Поисковая выдача",
  category_search: "Та же категория",
} as const;

export const COMPETITOR_CANDIDATE_DETAILS_STATUS_LABELS = {
  ok: "Загружены",
  unavailable: "Недоступны",
} as const;

export const COMPETITOR_ANALYSIS_SIGNAL_LABELS = {
  ABOVE_MARKET_PRICE: "Цена выше рынка",
  BELOW_MARKET_PRICE: "Цена ниже рынка",
  COMPETITOR_GROWTH: "Конкурент растёт быстрее",
  MARKET_DECLINE: "Рынок снижается",
  VISIBILITY_GAP: "Слабее видимость",
  STRONG_CHEAPER_COMPETITOR: "Сильный более дешёвый конкурент",
  CARD_QUALITY_GAP: "Карточка слабее",
  INSUFFICIENT_MARKET_DATA: "Мало рыночных данных",
} as const;
